import Vue from 'vue'
import VueRouter from 'vue-router'
import NewArticles from '@/views/NewArticles.vue'
import HomeBlog from '@/views/HomeBlog.vue'
import Craft from '@/views/Craft.vue'
import HomeBlogArticles from '@/views/HomeBlogArticles.vue'
import JourneyArticles from '@/views/JourneyArticles.vue'

import Countries from '@/views/Countries.vue'
import Journeys from '@/views/Journeys.vue'
import History from '@/views/History.vue'
import Immigration from '@/views/Immigration.vue'
import Piter from '@/views/Piter.vue'

import ManageArticle from '@/views/ManageArticle.vue'
import Article from '@/views/Article.vue'
import SharedArticle from '@/views/SharedArticle.vue'

import LoginUser from '@/views/LoginUser.vue'
import LogoutUser from '@/views/LogoutUser.vue'

import NotFound from '@/views/NotFound.vue'

import store from '@/store/store'

import APIService from '@/apiservices/APIService.js'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: { name: 'new-articles' }
  },
  {
    path: '/new',
    name: 'new-articles',
    component: NewArticles,
    meta: { requiresAuth: true }
  },
  {
    path: '/homeblog',
    name: 'home-blog',
    component: HomeBlog,
    meta: { requiresAuth: true }
  },
  {
    path: '/articles',
    name: 'articles',
    component: HomeBlogArticles,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/countries',
    name: 'countries',
    component: Countries,
    meta: { requiresAuth: true }
  },
  {
    path: '/immigration',
    name: 'immigration',
    component: Immigration,
    meta: { requiresAuth: true }
  },
  {
    path: '/journeys',
    name: 'journeys',
    component: Journeys,
    meta: { requiresAuth: true }
  },
  {
    path: '/craft',
    name: 'craft',
    component: Craft,
    meta: { requiresAuth: true }
  },
  {
    path: '/oldstories',
    name: 'oldstories',
    component: History,
    meta: { requiresAuth: true }
  },
  {
    path: '/piter',
    name: 'piter',
    component: Piter,
    meta: { requiresAuth: true }
  },
  {
    path: '/managearticle/:article_id?', // Вопросительный знак в конце говорит, что параметр опционален
    name: 'manage-article',
    component: ManageArticle,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/article/:article_id',
    name: 'article',
    component: Article,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/shared/:share_code',
    name: 'sharedarticle',
    component: SharedArticle,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/jarticles',
    component: JourneyArticles,
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/logout',
    name: 'logout',
    component: LogoutUser,
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    component: LoginUser
  },
  {
    path: '/404',
    name: '404',
    component: NotFound
  },
  {
    path: '*',
    redirect: { name: '404' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  APIService.getVersion()
    .then(response => {
      console.log(
        'CURRENT VERSION:',
        from.name,
        store.getters.getVersion.number
      )
      console.log('CHECKING VERSION:', response.data.results[0].number)
      let newversion = response.data.results[0]
      if (
        from.name != null &&
        newversion.number != store.getters.getVersion.number
      ) {
        console.log('NEW VERSION:', newversion.number)
        newversion.newversion = true
        store.commit('SET_VERSION', newversion)
      }
    })
    .catch(error => {
      console.log('There was an error in fetching version:', error)
    })
  console.log('Trying to access page to:', to)
  console.log('Trying to access page from:', from)
  console.log('Trying to access page next:', next)
  const loggedIn = localStorage.getItem('user')
  //На самом деле тут бы хорошо использовать store.getters.loggedIn.
  //но он наполняяется в main.js  позже, чем сррабатывает рроутер и не успевает считать user из localStorage
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    console.log('NOT AUTHORIZED')
    //Мы не залогинены, а пытаемся зайти на страницу требующую авторизации.
    //Запоминаем куда мы шли, для того чтобы туда пойти после логина
    store.dispatch('rememberURLBeforeLogin', to.fullPath)
    //Переходим на страницу логина (логаутить нас не надо, мы и так не залогинены)
    
    next('/login')
    
    return false
  }
  next()
})

export default router
